import { createSelector } from "@reduxjs/toolkit";
import { AppState } from "@store/app/app-slice";
import { RootState } from "@store/store-helper";

/**
 * Selector to get the entire app state.
 */
export const appStateSelector = createSelector(
  (state: RootState) => state.app,
  (app): AppState => {
    return {
      isAlphaTestingEnabled: app.isAlphaTestingEnabled,
      isBetaTestingEnabled: app.isBetaTestingEnabled,
      isDevModeEnabled: app.isDevModeEnabled,
    };
  }
);
